/**
 * WorkspaceService – handles workspace data operations including save to Cosmos DB
 */
import { httpPost } from './httpService';
import { environment } from '../environments/environment';
import { WORKSPACE_DEPARTMENT_API, PUBLISH_DEPARTMENT_API } from '../constants';
import type { SaveRequest, SaveResponse, PublishStateModel } from '../models';

/**
 * Save workspace data to Cosmos DB
 * @param departmentId - Department ID
 * @param requestBody - Save request containing changed cell data
 * @returns SaveResponse with success status and new stateGuid
 */
export async function saveWorkspaceData(
  departmentId: number,
  requestBody: SaveRequest
): Promise<SaveResponse> {
  const url = environment.apiConfig.articleplan_api.uri + WORKSPACE_DEPARTMENT_API + departmentId;
  return httpPost<SaveRequest, SaveResponse>(url, requestBody);
}

/**
 * Publish workspace data to Cosmos DB
 * @param departmentId - Department ID to publish
 * @returns PublishStateModel with published metadata for store and online channels
 */
export async function publishDepartment(
  departmentId: number
): Promise<PublishStateModel> {
  const url = environment.apiConfig.articleplan_api.uri + PUBLISH_DEPARTMENT_API + departmentId;
  return httpPost<null, PublishStateModel>(url, null);
}
